<template>
	<div class="container-layout form px-0">
		<filter-budget-advanced
			hide-supplier-section
			:show-type-selector="false"
			:label-expense-details="FormMSG(148, 'Salary details')"
			hide-expense-details-type
			use-department-for-salary
			:hide-process-filter="false"
			:filter-type="1"
			@filter-budget-advanced:click-selection="handleFilterBudgetAdvancedClickSelection"
		/>
		<div class="d-flex row align-items-center mt-3 hide-on-tablet">
			<b-col md="5">
				<b-form-group class="mb-0">
					<b-input-group v-if="$screen.width >= 992">
						<filterInputSearch id="salaire-id" @filtered-users="activeFilter" @handle-init-filter="onHandleInitFilter" />
						<!-- <b-form-input v-model="filter" type="text" id="filterInput" :placeholder="this.FormMSG(37, 'Type to Search')" />
						<b-input-group-append class="cursor-pointer">
							<b-input-group-text class="btn-search">
								<Search color="#FFFFFF" :size="16" class="icon" :stroke-width="2.5" v-if="filter.length === 0" />
								<X color="#FFFFFF" :size="16" class="icon" :stroke-width="2.5" @click="filter = ''" v-else />
							</b-input-group-text>
						</b-input-group-append> -->
					</b-input-group>
				</b-form-group>
			</b-col>
			<b-col md="7">
				<custom-pagination
					v-if="!haveActiveFilter"
					:total-records="totalRecords"
					:initial-offset="offset"
					:initial-limit="limit"
					:filter-type="1"
					@custom-pagination:previous="handleCustomPaginationPrevious"
					@custom-pagination:forward="handleCustomPaginationForward"
					@custom-pagination:change-per-page="handleCustomPaginationChangePerPage"
				/>
			</b-col>
		</div>
		<div class="row mt-3 px-3">
			<CardListBuilder custom-class="hide-on-desktop" v-if="!$screen.md" :items="salaries" :filter="filter" style="width: 100%" :fields="bgFieldsMobile">
				<template slot="actions" slot-scope="data">
					<div @click="goToDetail(data.item)" role="button"><eye :size="16" /> {{ FormMSG(1001, 'See details') }}</div>
				</template>
			</CardListBuilder>
			<b-table
				v-else
				responsive="sm"
				:filter="filter"
				:items="salaries"
				:fields="bgFields"
				style="width: 100%; font-weight: 500"
				sticky-header="700px"
				:head-variant="hv"
				:hover="true"
				bordered
				small
				show-empty
				selectable
				:selectedVariant="selectedColor"
				:select-mode="selectMode"
				:empty-text="FormMSG(285, 'No budget salaries found')"
			>
				<template #cell(processed)="{ item, index }">
					<div>
						<b-form-checkbox
							v-model="item.timesheet.processed"
							size="lg"
							:value="true"
							:unchecked-value="false"
							@change="handleChangeProcess($event, item, index)"
						/>
					</div>
				</template>
				<template #cell(categorySelect)="{}">
					<div>
						<treeselect
							:options="allCategories"
							:multiple="false"
							:clearable="false"
							disable-branch-nodes
							:default-expand-level="1"
							@input="handleInputCategorySelect"
						>
							<div slot="option-label" slot-scope="{ node }">
								<div class="treeselect-label" :title="node.label">
									{{ node.label }}
								</div>
							</div>
						</treeselect>
					</div>
				</template>
				<template #cell(validatedStatus)="data">
					<div class="wrap-status">
						<div :class="`status ${data.item.statusClass}`" style="font-size: 0.7rem">
							{{ data.item.validatedStatus }}
						</div>
					</div>
				</template>
				<template #cell(detail)="data">
					<div @click="goToDetail(data.item)" role="button">
						<eye :size="16" />
					</div>
				</template>
			</b-table>
		</div>
		<script-export-modal
			v-model="isScriptTimeSheetReportOpen"
			:items="scripts"
			:custom="customReport"
			export-type="ts"
			@script-export-modal:loading="handleTimesheetLoading"
			@script-export-modal:closed="timeSheetRerpotOnClosed"
		/>
	</div>
</template>

<script>
import languageMessages from '@/mixins/languageMessages';
import { rendCurrency, rendKgCo2 } from '~helpers';
import { Eye, Search, X, AlertTriangle } from 'lucide-vue';
import GlobalMixin from '@/mixins/global.mixin';
import moment from 'moment';
import { getTextFromMenuNumberAndMenuValue } from '@/cruds/language.crud';
import FilterBudgetAdvanced from '@/components/Budget/FilterBudgetAdvanced';
// import { getProjectUserSalaries, getBudgetHierarchicalCategoryJson } from '@/cruds/budget.crud'
import { store } from '@/store';
import Treeselect from '@riophae/vue-treeselect';
import CustomPagination from '@/components/Budget/CustomPagination';
import _ from 'lodash';
import filterInputSearch from '../users/filterInput.vue';
import { getScripts } from '@/cruds/script.crud';
import { timeSheetReport } from '@/cruds/export.crud';
import ScriptExportModal from '@/components/Export/ScriptExportModal';
import { FILENAME_REPORT, OUTPUT_FORMAT_EXPORT } from '@/shared/constants';
import { formatFileName } from '~utils';
import { getFileExtension } from '@/shared/helpers';
import { changeStatusOfProcess } from '@/cruds/budget.crud';

const validatedText = async (validated) => {
	let value = null;
	await new Promise((resolve, reject) => {
		resolve(getTextFromMenuNumberAndMenuValue(1008, validated));
		reject(false);
	}).then((data) => {
		value = data;
	});

	return value;
};
const validatedColor = (validated) => {
	let retval = 'not-submitted';
	if (validated == 1) {
		retval = 'info';
	} else if (validated == 2) {
		retval = 'pending';
	} else if (validated == 8) {
		retval = 'validated';
	} else if (validated == 4 || validated == 16) {
		retval = 'refused';
	}
	return retval;
};

export default {
	name: 'BudgetSalaries',
	components: {
		Eye,
		FilterBudgetAdvanced,
		Search,
		X,
		Treeselect,
		filterInputSearch,
		AlertTriangle,
		CustomPagination,
		ScriptExportModal
	},
	mixins: [languageMessages, GlobalMixin],
	props: {
		initDataForFilterAdvanced: { type: Object, required: true },
		budgetSalariesData: { type: Array, required: true },
		totalRecords: { type: Number, required: true }
	},
	data() {
		return {
			visible: false,
			keyword: null,
			caption1: '',
			hv: 'dark',
			haveActiveFilter: false,
			salaries: [],
			filter: '',
			filterForDownload: {
				startDate: '',
				endDate: ''
			},
			filtersSelected: {},
			firstLoad: true,
			selectMode: 'single',
			selectedColor: 'primary',
			perPage: 100,
			offset: 0,
			limit: 100,
			cookiesPaginationBudgetSalaries: 'pagination_budget_salaries',
			isScriptTimeSheetReportOpen: false,
			scripts: [],
			customReport: null,
			scriptType: 11,
			removeFromReportKeys: []
		};
	},
	watch: {
		budgetSalariesData: {
			async handler(val) {
				let arr = [];
				const data = val;
				for (const item of data) {
					item.statusClass = validatedColor(item.status);
					item.validatedStatus = await validatedText(item.status);
					arr.push(item);
				}
				this.salaries = arr;
			},
			immediate: true,
			deep: false
		}
	},
	computed: {
		bgFields() {
			return [
				{
					key: 'processed',
					label: this.FormMSG(561, 'Processed'),
					sortable: false,
					class: 'text-center w-90-px'
				},
				{
					key: 'startDate',
					label: this.FormMSG(16, 'Stard Date'),
					formatter: (value) => {
						return moment(value).format('DD/MM/YYYY');
					},
					sortable: true,
					class: 'text-center'
				},
				{
					key: 'endDate',
					label: this.FormMSG(20, 'End Date'),
					formatter: (value) => {
						return moment(value).format('DD/MM/YYYY');
					},
					sortable: true,
					class: 'text-center'
				},
				{
					key: 'fullName',
					label: this.FormMSG(21, 'Full Name'),
					sortable: true,
					class: 'text-left'
				},
				{
					key: 'departmentAndFunction',
					label: this.FormMSG(122, 'Department & Function'),
					formatter: (value, key, item) => {
						return `${item.departmentName} - ${item.functionName}`;
					},
					sortable: true,
					class: 'text-left'
				},
				{
					key: 'costCenterAndcategoryName',
					label: this.FormMSG(123, 'Category'),
					formatter: (valu, key, item) => {
						return `${item.categoryCostCenter} - ${item.categoryName}`;
					},
					sortable: true,
					class: 'text-left w-250-px'
				},
				{
					key: 'validatedStatus',
					label: this.FormMSG(24, 'Status'),
					sortable: true,
					class: 'text-center'
				},
				{
					key: 'hoursStr',
					label: this.FormMSG(127, 'Hours'),
					formatter: (value) => value,
					class: 'text-center',
					sortable: true
				},
				{
					key: 'salary',
					label: this.FormMSG(25, 'Salary'),
					formatter: (value) => {
						return this.displayCurrency(value);
					},
					sortable: true,
					class: 'text-right'
				},
				{
					key: 'co2',
					label: 'CO2',
					formatter: (value) => {
						return this.displayKgCo2(value);
					},
					class: 'text-right',
					sortable: true
				},
				{
					key: 'detail',
					label: this.FormMSG(128, 'Details'),
					class: 'text-center'
				}
			];
		},
		bgFieldsMobile() {
			return [
				{
					key: 'startDate',
					label: this.FormMSG(16, 'Stard Date'),
					formatter: (value) => {
						return moment(value).format('DD/MM/YYYY');
					},
					sortable: true,
					class: 'text-center'
				},
				{
					key: 'endDate',
					label: this.FormMSG(20, 'End Date'),
					formatter: (value) => {
						return moment(value).format('DD/MM/YYYY');
					},
					sortable: true,
					class: 'text-center'
				},
				{
					key: 'fullName',
					label: this.FormMSG(21, 'Full Name'),
					sortable: true,
					class: 'text-left'
				},
				{
					key: 'departmentAndFunction',
					label: this.FormMSG(122, 'Department & Function'),
					formatter: (value, key, item) => {
						return `${item.departmentName} - ${item.functionName}`;
					},
					sortable: true,
					class: 'text-left'
				},
				{
					key: 'categorySelect',
					label: this.FormMSG(123, 'Category'),
					sortable: false,
					class: 'text-left'
				},
				{
					key: 'validatedStatus',
					label: this.FormMSG(24, 'Status'),
					sortable: true,
					class: 'text-left'
				},
				{
					key: 'hoursStr',
					label: this.FormMSG(127, 'Hours'),
					formatter: (value) => value,
					class: 'text-center',
					sortable: true
				},
				{
					key: 'salary',
					label: this.FormMSG(25, 'Salary'),
					formatter: (value) => {
						return this.displayCurrency(value);
					},
					sortable: true,
					class: 'text-right'
				},
				{
					key: 'co2',
					label: 'CO2',
					formatter: (value) => {
						return this.displayKgCo2(value);
					},
					class: 'text-right',
					sortable: true
				}
			];
		}
	},
	created() {
		this.caption1 = this.FormMSG(1, 'Show filters');
	},
	async mounted() {
		this.$bus.$on('filter-budget-advanced:clear-filters', () => {
			this.offset = 0;
			this.limit = this.perPage;
		});
	},
	methods: {
		activeFilter(keyword) {
			this.haveActiveFilter = true;
			this.$emit('activate-filter-by-keyword', keyword);
		},
		onHandleInitFilter() {
			this.filter = '';
			this.keyword = null;
			this.haveActiveFilter = false;
			this.$emit('activate-filter-by-keyword', this.keyword);
		},
		async handleChangeProcess(payload, item, index) {
			await changeStatusOfProcess(+item.timesheet.id, 0, payload);
		},
		handleCustomPaginationPrevious({ offset, limit, perPage }) {
			this.offset = offset;
			this.limit = limit;
			this.perPage = perPage;
			this.$emit('budget-salaries:previous', {
				offset,
				limit,
				perPage
			});
		},
		handleCustomPaginationForward({ offset, limit, perPage }) {
			this.offset = offset;
			this.limit = limit;
			this.perPage = perPage;
			this.$emit('budget-salaries:forward', {
				offset,
				limit,
				perPage
			});
		},
		handleCustomPaginationChangePerPage({ offset, limit, perPage }) {
			this.offset = offset;
			this.limit = limit;
			this.perPage = perPage;
			this.$emit('budget-salaries:change-per-page', {
				offset,
				limit,
				perPage
			});
		},
		handleClickLoadMore({ offset, limit, perPage }) {
			this.offset = offset;
			this.limit = limit;
			this.perPage = perPage;

			this.$emit('budget-salaries:load-more', {
				offset,
				limit,
				perPage
			});
		},
		async handleFilterBudgetAdvancedClickSelection(oPayload) {
			this.emitLoading(true);
			const payload = _.omit(oPayload, this.removeFromReportKeys);

			this.scripts = await getScripts(store.state.myProject.licenseID, store.state.myProject.id, this.scriptType, true);

			let script = { id: 0, fileName: null, ext: 'xlsx' };

			if (this.scripts.length > 1) {
				this.customReport = payload;
				this.isScriptTimeSheetReportOpen = true;
				this.emitLoading(false);
			} else {
				this.customReport = null;

				if (this.scripts.length === 1) {
					script = {
						id: this.scripts[0].id,
						fileName: this.scripts[0].customExportFileName,
						ext: this.getExtensionScript(
							OUTPUT_FORMAT_EXPORT.at(this.scripts[0].outputFileFormat),
							this.scripts[0].customExtension,
							getFileExtension(this.scripts[0].fileName)
						)
					};
				}

				let fileName = this.getFileNameScript(FILENAME_REPORT.REPORT_TS, script.id, script.fileName);

				await timeSheetReport(payload, script.id)
					.then((result) => {
						this.forceDownload(result, fileName + '.' + script.ext);
					})
					.catch((e) => {
						console.error(e);
						this.emitLoading(false);
					})
					.finally(() => {
						this.emitLoading(false);
					});
			}
		},
		goToDetail(item) {
			this.$router.push({ path: `/mytimesheets/${item.id.toString()}?budgetSalaries=1` });
		},
		displayCurrency(value) {
			return rendCurrency(value);
		},
		displayKgCo2(value) {
			return rendKgCo2(value);
		},
		emitLoading(value) {
			this.$emit('budget-salaries:loading', value);
		},
		timeSheetRerpotOnClosed() {
			this.isScriptTimeSheetReportOpen = false;
			this.emitLoading(false);
		},
		handleTimesheetLoading(payload) {
			if (payload) {
				this.emitLoading(false);
			}
		}
	}
};
</script>
